import React from 'react';

import FileUpload from '../editor/FileUpload'
import Link from '../editor/Link'
import Search from '../editor/Search'

const BCollectionTileEditor = (props) => {
    return (
        <div>
            {props.children}
            <Search />
            <hr />
            <Link value={props.settings.link} />
            <div className="form-group">
                <label className="col-sm-3 control-label">Tytuł</label>
                <div className="col-sm-9">
                    <input type="text" name="title_normal" className="form-control" defaultValue={props.settings.title_normal} placeholder="" />
                </div>
            </div>
            <div className="form-group">
                <label className="col-sm-3 control-label">Tytuł dolny</label>
                <div className="col-sm-9">
                    <input type="text" name="label" className="form-control" defaultValue={props.settings.label} placeholder="" />
                </div>
            </div>
            <div className="form-group">
                <label className="col-sm-3 control-label">Czas w formacie "RRRR-MM-DD GG:mm"</label>
                <div className="col-sm-9">
                    <input type="text" name="time" className="form-control" defaultValue={props.settings.time} placeholder="" />
                </div>
            </div>
            <div className="form-group">
                <label className="col-sm-3 control-label">Liczba zdjęć</label>
                <div className="col-sm-9">
                    <input type="text" name="photo_count" className="form-control" defaultValue={props.settings.photo_count} placeholder="" />
                </div>
            </div>
            <FileUpload value={props.settings['background-image']} />
        </div>
    );
}


export default BCollectionTileEditor;